import { render, staticRenderFns } from "./GenderModal.vue?vue&type=template&id=5633ed34&"
import script from "./GenderModal.vue?vue&type=script&lang=js&"
export * from "./GenderModal.vue?vue&type=script&lang=js&"
import style0 from "./GenderModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports